 function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }// Firefox < 140 (released 2025-06-24) does not support cookieStore API
import Cookies from 'js-cookie'

const cookieName = 'authToken'

export const getAuthCookie = (global) => {
  if (!global) return null
  return _nullishCoalesce(Cookies.get(cookieName), () => ( null))
}

export const onAuthCookieChange = (global, callback) => {
  if (!global) return undefined
  const cookieStore = global.cookieStore
  if (!cookieStore) {
    return undefined
  }

  const listener = (event) => {
    const authCookieChange = event.changed.find((change) => change.name === cookieName)
    if (authCookieChange) {
      const newValue = _nullishCoalesce(authCookieChange.value, () => ( null))
      callback(newValue)
    }
  }
  cookieStore.addEventListener('change', listener)
  return () => {
    cookieStore.removeEventListener('change', listener)
  }
}
